import React from 'react'
import moment from 'moment'
import NumberFormat from 'react-number-format'

/**
 * Percent formatter
 *
 * Color positive and negative numbers in different colors.
 *
 * @param number
 * @return {*}
 */
export const numberPercentFormatter = number => {
	return <span className={number > 0 ? 'u-text--apple' : 'u-text--monza'}>{parseFloat(number).toFixed(2)}%</span>
}

/**
 * Labels formatter
 *
 * Format date based on type filter
 *
 * @param number
 * @return {*}
 */
export const labelsFormatter = (date, filter) => {
	if (filter === 'day') return moment(date).format('HH:mm')

	const month = moment(date).format('MMMM')
	if (filter === 'year') return month.charAt(0).toUpperCase() + month.slice(1)

	if (filter === 'fiveYears') return moment(date).format('YYYY')

	return moment(date).format('DD.MM')
}

export const numberFormatter = ({value, thousandSeparator, prefix, suffix}) => {
	return <NumberFormat value={value} displayType={'text'} thousandSeparator={thousandSeparator} prefix={prefix} suffix={suffix}/>
}